// src/pages/Umivalniki.tsx
import CategoryPage from './CategoryPage';

const Umivalniki = () => {
  const subcategories = [
    {
      title: "Stekleni umivalniki",
      imageSrc: "https://images.unsplash.com/photo-1600566752610-111d521cf1de?auto=format&fit=crop&q=80",
      url: "/umivalniki/stekleni"
    },
    {
      title: "Glineni umivalniki",
      imageSrc: "https://images.unsplash.com/photo-1617004518200-f3b8191fdc1d?auto=format&fit=crop&q=80",
      url: "/umivalniki/glineni"
    },
    {
      title: "Betonski umivalniki",
      imageSrc: "https://images.unsplash.com/photo-1600566752427-25ef8fb4e018?auto=format&fit=crop&q=80",
      url: "/umivalniki/betonski"
    },
    {
      title: "Resina umivalniki",
      imageSrc: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80",
      url: "/umivalniki/resina"
    },
    {
      title: "Marmorni umivalniki",
      imageSrc: "https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80",
      url: "/umivalniki/marmorni"
    },
    {
      title: "Leseni umivalniki",
      imageSrc: "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?auto=format&fit=crop&q=80",
      url: "/umivalniki/leseni"
    },
    {
      title: "Metal umivalniki",
      imageSrc: "https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80",
      url: "/umivalniki/metal"
    }
  ];

  return (
    <CategoryPage
      title="Umivalniki"
      description="Odkrijte našo ekskluzivno kolekcijo umivalnikov iz različnih materialov, oblikovanih za popolno kombinacijo estetike in funkcionalnosti."
      heroImage="https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80"
      subcategories={subcategories}
    />
  );
};

export default Umivalniki;